<template>
  <div class="notification">
    <h6>{{ status }}</h6>
    <button @click="handleClick">{{ desc }}</button>
  </div>
</template>

<script>
export default {
  props: {
    desc: {
      type: String,
      required: true,
    },
    status: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClick() {
      this.$emit("retryUpload");
    },
  },
};
</script>

<style>
.Vue-Toastification__toast-component-body p {
  margin: 0;
}
.notification {

}
button {
  background-color: transparent;
  color: white;
  border: none;
  text-decoration: underline;
}
</style>
